export enum ContentRequestType {
	ALL = 'All',
	ON_HOLD_MESSAGE = 'On-Hold Message',
	VIDEO_LOBBY = 'Video-Lobby',
	VIDEO_CREATE24_TEMPLATE = 'Video-Create24 Template',
	VIDEO_LOGO = 'Video-Logo',
	VIDEO_POSTER = 'Video-Poster',
	VIDEO_OTHER = 'Video-Other'
}
